@if (summary()) {
  <div class="retail-summary">
    <div class="retail-summary-header">
      <span class="title">{{ 'INVENTORY_UI.RETAIL_SUMMARY.TITLE' | translate }}</span>
    </div>

    <mat-divider></mat-divider>

    <div class="pricing-row subtotal">
      <span>{{ 'INVENTORY_UI.RETAIL_SUMMARY.SUBTOTAL' | translate }}</span>
      <span class="pricing">
        <billing-ui-simple-price-display
          [price]="summary().subtotal"
          [currencyCode]="summary().currencyCode"
          [alwaysShowNumber]="true"
        ></billing-ui-simple-price-display>
      </span>
    </div>

    @if (summary().taxAmount > 0) {
      <div class="pricing-row taxes">
        <span>{{ 'INVENTORY_UI.RETAIL_SUMMARY.TAXES' | translate }}</span>
        <span class="pricing">
          <billing-ui-simple-price-display
            [price]="summary().taxAmount"
            [currencyCode]="summary().currencyCode"
            [alwaysShowNumber]="true"
          ></billing-ui-simple-price-display>
        </span>
      </div>
    }

    <mat-divider></mat-divider>

    <div class="pricing-row due-now">
      <span>{{ 'INVENTORY_UI.RETAIL_SUMMARY.DUE_NOW' | translate }}</span>
      <span class="pricing">
        <billing-ui-simple-price-display
          [price]="summary().firstPayment"
          [currencyCode]="summary().currencyCode"
          [alwaysShowNumber]="true"
        ></billing-ui-simple-price-display>
      </span>
    </div>
  </div>
}
